function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { WDHComponent, resolveImageSrc } from '@demant/wdh';

/**
 * @memberOf module: component-timeline-spot
 */
var DemantVerticalLineSpot = /*#__PURE__*/function (_WDHComponent) {
  /**
   * @param {String} className - The unique css selector that triggers the component
   * @constructor
   * @augments WDHComponent
   * @inheritDoc
   */
  function DemantVerticalLineSpot() {
    var _this;
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'vertical-line-spot';
    _classCallCheck(this, DemantVerticalLineSpot);
    _this = _callSuper(this, DemantVerticalLineSpot, [className]);

    /**
     * Set a callback function to override the default logic for when to switch between
     * *mobile* and *desktop* views. Return true to go to *mobile*, return false to go to
     * *desktop*.
     * @type {function(int, int): boolean}
     */
    _this.resolveMobileBreakPoint = _this.defaultResolveMobileBreakPoint;

    /**
     * Sets the number of visible dates on the timeline.
     * @type {number}
     * @default 15
     */
    // Make visibleDateCountResponsive
    _this.visibleDateCount = 15;
    return _this;
  }
  _inherits(DemantVerticalLineSpot, _WDHComponent);
  return _createClass(DemantVerticalLineSpot, [{
    key: "init",
    value: function init(component) {
      var settings = this.getDataFromComponent(component);
      ReactDOM.render(/*#__PURE__*/React.createElement(App, {
        timelineItems: settings.timelineItems,
        visibleDateCount: this.visibleDateCount
      }), component.querySelector('.component-content'));
    }

    /**
    * Get the rendered settings for the component instance given by *component*
    * @param component
    * @private
    */
  }, {
    key: "getDataFromComponent",
    value: function getDataFromComponent(component) {
      var timelineItemsLi = component.querySelectorAll('ul li');
      var timelineItems = [];
      timelineItemsLi.forEach(function (li) {
        var date = li.querySelector('.vertical-line-item-text .vertical-line-item-header h2').innerHTML;
        var text = li.querySelector('.vertical-line-item-text .vertical-line-item-body').innerHTML;
        var imgSrc = resolveImageSrc(li.querySelector('.vertical-line-item-image img'));
        timelineItems.push({
          date: date,
          text: text,
          imgSrc: imgSrc
        });
      });
      return {
        timelineItems: timelineItems
      };
    }
  }]);
}(WDHComponent);
var App = /*#__PURE__*/function (_React$Component) {
  function App(props) {
    var _this2;
    _classCallCheck(this, App);
    _this2 = _callSuper(this, App, [props]);
    _this2.state = {
      activeItem: {},
      currentIndex: 0,
      readMore: false
    };
    _this2.onArrowUpClick = _this2.onArrowUpClick.bind(_this2);
    _this2.onArrowDownClick = _this2.onArrowDownClick.bind(_this2);
    _this2.onDateClick = _this2.onDateClick.bind(_this2);
    return _this2;
  }
  _inherits(App, _React$Component);
  return _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateState({
        activeItem: this.props.timelineItems[this.state.currentIndex]
      });
    }
  }, {
    key: "onDateClick",
    value: function onDateClick(item, e) {
      e.preventDefault();
      this.updateState({
        readMore: false
      });
      this.updateState({
        activeItem: item,
        readMore: false
      });
      this.singleDateActive = true;
      return this.singleDateActive;
    }
  }, {
    key: "onArrowUpClick",
    value: function onArrowUpClick(e) {
      e.preventDefault();
      var dateContainer = this.getDateContainer();
      var newScrollTop = dateContainer.scrollTop - 200;
      var arrowUp = document.querySelector('.timeline-dates .timeline-arrow:first-child');
      var arrowDown = document.querySelector('.timeline-dates .timeline-arrow:last-child');
      var isSmoothScrollSupported = 'scrollBehavior' in dateContainer.style;
      if (isSmoothScrollSupported) dateContainer.scrollTo({
        top: newScrollTop,
        behavior: 'smooth'
      });else dateContainer.scrollTop = newScrollTop; //IE fallback

      if (newScrollTop <= 0) {
        arrowUp.classList.add('disabled');
      } else {
        arrowUp.classList.remove('disabled');
      }
      arrowDown.classList.remove('disabled');
    }
  }, {
    key: "onArrowDownClick",
    value: function onArrowDownClick(e) {
      e.preventDefault();
      var dateContainer = this.getDateContainer();
      var newScrollTop = dateContainer.scrollTop + 200;
      var arrowUp = document.querySelector('.timeline-dates .timeline-arrow:first-child');
      var arrowDown = document.querySelector('.timeline-dates .timeline-arrow:last-child');
      var isSmoothScrollSupported = 'scrollBehavior' in dateContainer.style;
      if (isSmoothScrollSupported) dateContainer.scrollTo({
        top: newScrollTop,
        behavior: 'smooth'
      });else dateContainer.scrollTop = newScrollTop; //IE fallback

      if (newScrollTop + dateContainer.offsetHeight >= dateContainer.scrollHeight) {
        arrowDown.classList.add('disabled');
      } else {
        arrowDown.classList.remove('disabled');
      }
      arrowUp.classList.remove('disabled');
    }
  }, {
    key: "getTimeLineDates",
    value: function getTimeLineDates() {
      var timeLineDates = /*#__PURE__*/React.createElement("div", {
        className: "timeline-dates"
      }, /*#__PURE__*/React.createElement("button", {
        className: "timeline-arrow disabled",
        onClick: this.onArrowUpClick
      }, /*#__PURE__*/React.createElement("i", {
        className: "material-icons"
      }, "keyboard_arrow_up")), /*#__PURE__*/React.createElement("div", {
        className: "date-container"
      }, this.getDates()), /*#__PURE__*/React.createElement("div", {
        className: "date-container__overlay date-container__overlay--left"
      }), /*#__PURE__*/React.createElement("div", {
        className: "date-container__overlay"
      }), /*#__PURE__*/React.createElement("button", {
        className: "timeline-arrow",
        onClick: this.onArrowDownClick
      }, /*#__PURE__*/React.createElement("i", {
        className: "material-icons"
      }, "keyboard_arrow_down")));
      return timeLineDates;
    }
  }, {
    key: "getDateContainer",
    value: function getDateContainer() {
      var container = document.querySelector('.timeline-dates .date-container');
      return container;
    }
  }, {
    key: "getDates",
    value: function getDates() {
      var _this3 = this;
      var dates = [];
      var i = this.state.currentIndex;
      var max = this.state.currentIndex + this.props.timelineItems.length;
      var _loop = function _loop() {
        var item = _this3.props.timelineItems[i];
        var date = /*#__PURE__*/React.createElement("button", {
          className: "date",
          key: item.date,
          onClick: function onClick(e) {
            return _this3.onDateClick(item, e);
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: _this3.isActive(item) ? 'active' : '',
          dangerouslySetInnerHTML: {
            __html: item.date
          }
        }));
        dates.push(date);
      };
      for (i; i < max; i += 1) {
        _loop();
      }
      if (i < this.props.timelineItems.length) {
        dates.push(/*#__PURE__*/React.createElement("div", {
          key: "overlay",
          className: "date-container__overlay"
        }));
      }
      return dates;
    }
  }, {
    key: "isActive",
    value: function isActive(item) {
      return this.state.activeItem === item;
    }
  }, {
    key: "resolveMobile",
    value: function resolveMobile() {
      return window.matchMedia('(max-width:991px)').matches;
    }
  }, {
    key: "updateState",
    value: function updateState(state, cb) {
      this.setState(state, cb);
    }
  }, {
    key: "readMore",
    value: function readMore() {
      this.setState({
        readMore: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var isExpanded = this.state.readMore || !this.state.activeItem.text || this.state.activeItem.text.length <= 290;
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.getTimeLineDates(), /*#__PURE__*/React.createElement("div", {
        className: "timeline-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "timeline-img",
        style: {
          backgroundImage: "url(".concat(this.state.activeItem.imgSrc, ")")
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "timeline-text ".concat(isExpanded ? 'expanded' : '')
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: this.state.activeItem.text
        }
      }), !isExpanded && /*#__PURE__*/React.createElement("button", {
        className: "timeline-text__read-more",
        onClick: function onClick() {
          _this4.readMore();
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "material-icons"
      }, "keyboard_arrow_down")))));
    }
  }]);
}(React.Component);
App.propTypes = {
  timelineItems: PropTypes.arrayOf(PropTypes.object).isRequired
};
var timeline = new DemantVerticalLineSpot();
timeline.run();